module.exports = __webpack_public_path__ + "img/harbor.1d56dfd8.svg";